<template>
  <keep-alive>
    <div class="container flex flex-col mx-auto">
      <Gallery></Gallery>
    </div>
  </keep-alive>
</template>

<script lang="ts" setup>
//  作品展示
useHead({
  title: '作品展示',
})
</script>

<style></style>
